import { MEDICAL_INSTITUTIONS_ACTIONS } from 'constants/Actions/MedicalInstitutions';

// Estado inicial del reducer
const aInitialState = {
    aMedicalInstitutions: [],
    nTotalPages: 0,

    oMedicalInstitution: null,

    bIsSuccess: false,
    bIsError: false,

    aMedicalInstitutionsSuggestion: [],
}
/**
 * Reducer que sera utilizado para controlar los datos referidos a las instituciones medicas del sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const MedicalInstitutionReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case MEDICAL_INSTITUTIONS_ACTIONS.GET_ALL:
            return { ...aState, aMedicalInstitutions: oAction.data.data, nTotalPages: oAction.data.pages };
        case MEDICAL_INSTITUTIONS_ACTIONS.GET_ACTIVE:
            return { ...aState, aMedicalInstitutions: oAction.data.data, nTotalPages: oAction.data.pages };
        case MEDICAL_INSTITUTIONS_ACTIONS.FIND:
            return { ...aState, oMedicalInstitution: oAction.data };
        case MEDICAL_INSTITUTIONS_ACTIONS.ADD:
            return { ...aState, bIsSuccess: true, nMedicalInstitutionId: oAction.data };
        case MEDICAL_INSTITUTIONS_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case MEDICAL_INSTITUTIONS_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case MEDICAL_INSTITUTIONS_ACTIONS.CLEAN:
            return { ...aState, oMedicalInstitution: null, bIsSuccess: false, bIsError: false };
        case MEDICAL_INSTITUTIONS_ACTIONS.SUGGESTION:
            return { ...aState, aMedicalInstitutionsSuggestion: oAction.data };
        case MEDICAL_INSTITUTIONS_ACTIONS.SUGGESTION_CLEAN:
            return { ...aState, aMedicalInstitutionsSuggestion: [] };
        default:
            return aState;
    }
}
